import { render, staticRenderFns } from "./dealerDetail.vue?vue&type=template&id=21d4f6d5&scoped=true"
import script from "./dealerDetail.vue?vue&type=script&lang=js"
export * from "./dealerDetail.vue?vue&type=script&lang=js"
import style0 from "./dealerDetail.vue?vue&type=style&index=0&id=21d4f6d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4f6d5",
  null
  
)

export default component.exports